import React, {Component} from 'react'
import {List, ListItem, ListItemText, ListItemIcon, Typography, Button} from '@material-ui/core'

import DewarImage from "./DewarImage.png"
import DewarImageCompleted from "./DewarImageCompleted.png"

let formatDatetime = (datetime) => {
    let d = new Date(Date.parse(datetime))
    return `${d.getDate()} ${["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"][d.getMonth()]}`
}

/**
 * dewars
 * selected
 * 
 * onDewarClick(dewar)
 * onDewarDoubleClick(dewar)
 * onDewarStatusClick(dewar)
 * onCompletionClick(dewar)
 */

class DewarAccountingList extends Component {

    render() {

        return <List>
            {this.props.dewars.map((dewar, n) => {

                const handle_onClick = (e) => {
                    e.stopPropagation()
                    this.props.onDewarClick(dewar)
                }

                return <ListItem
                    key={n}
                    button
                    selected={this.props.selected ? this.props.selected.id === dewar.id : false}
                    onClick={handle_onClick}
                >
                    <ListItemIcon>
                        <img src={dewar.completion != 0 ? DewarImageCompleted : DewarImage} width={32} alt="show"/>
                    </ListItemIcon>                
                    <div style={{flex: "1 1 auto"}}>
                        <span style={{fontSize: "1.3em"}}>Получил: {dewar.user.name}</span><br />
                        Код: {dewar.dewar.code}<br />
                        <span style={{color: "#888", marginTop: "5px"}}>{dewar.comment}</span>
                    </div>
                    {/* <ListItemText 
                        primary={`Получил: ${dewar.user.name}`}
                        secondary={`Код сосуда: ${dewar.dewar.code}`} 
                    /> */}
                    {
                        dewar.completion === 1 ? 
                            <div style={{textAlign: "center", width: "130px", flex: "0 0 130px"}}>
                                Завершено<br/>{formatDatetime(dewar.completion_date) || "---"}
                            </div>
                        : 
                            <div style={{textAlign: "center", width: "130px", flex: "0 0 130px"}}>
                                {formatDatetime(dewar.date)}
                                <Button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        if (typeof this.props.onCompletionClick === "function") {
                                            this.props.onCompletionClick(dewar)
                                        }
                                    }}
                                >
                                    Завершить
                                </Button>
                            </div>                            
                    }
                </ListItem>}

            )}
        </List>

    }

}

export default DewarAccountingList